import { render, staticRenderFns } from "./DocumentToDownloadTable.vue?vue&type=template&id=88b3f0fc&"
import script from "./DocumentToDownloadTable.vue?vue&type=script&lang=js&"
export * from "./DocumentToDownloadTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports